// extracted by mini-css-extract-plugin
export default {"payBtn":"Gold_payBtn__mWG5Y","clicable":"Gold_clicable__qilSH","cohortBox":"Gold_cohortBox__OUT1q","cohortTop":"Gold_cohortTop__dzCWO","cohortBottom":"Gold_cohortBottom__rcC45"};